export const LOAN_INFO = [
  { key: "amountApproved", name: "amountApproved" },
  { key: "approvedTerm", name: "approvedTerm" },
  { key: "emi", name: "emi" },
  { key: "interest", name: "interest" },
  { key: "disbursementDate", name: "disbursementDate" },
  { key: "category", name: "category" },
  { key: "arrearsInDays", name: "arrearsInDays" },
  { key: "arrearsInDaysOld", name: "arrearsInDaysOld" },
  { key: "balanceToDate", name: "balanceToDate" },
];
export const BASIC_INFO = [
  { key: "customerUniqueId", name: "customerUniqueId" },
  { key: "fullName", name: "fullName" },
  { key: "telephoneNumber", name: "phoneNumber" },
  { key: "email", name: "email" },
  { key: "profession", name: "profession" },
  { key: "dateOfBirth", name: "dateOfBirth" },
  { key: "documentType", name: "documentType" },
  { key: "documentNumber", name: "documentNumber" },
  { key: "documentExpirationDate", name: "documentExpirationDate" },
  { key: "nationality", name: "nationality" },
];

export const BRANCH_INFO = [
  { key: "branchName", name: "branchName" },
  { key: "branchCode", name: "branchCode" },
  { key: "provincia", name: "provincia" },
];

export const APPRESTA_BRANCH_INFO = [
    { key: "agent", name: "agent" },
    { key: "masterAgent", name: "masterAgent" },
    { key: "network", name: "network" },
]

export const ASSOCIATION = [
  { key: "createdBy", name: "createdBY" },
  { key: "approvedBy", name: "approvedBy" },
  { key: "disbursedBy", name: "disbursedBy" },
];

export const PAYMENT_METHOD = [
  { key: "", value: "Seleccione el método de pago" },
  { key: "ONLINE", value: "En línea" },
  { key: "CASH", value: "Efectivo" },
  { key: "DIRECT_DEBIT", value: "Débito directo" },
  { key: "DEBIT_CARD", value: "Tarjeta de débito" },
];
